import { render } from "./CartTab.vue?vue&type=template&id=a680eef6&scoped=true"
import script from "./CartTab.vue?vue&type=script&lang=js"
export * from "./CartTab.vue?vue&type=script&lang=js"

import "./CartTab.vue?vue&type=style&index=0&id=a680eef6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a680eef6"]])

export default __exports__